import { motion } from "framer-motion";
import { IMAGES } from "../../data/content";
import { EASE, FadeIn, Eyebrow } from "./Reveal";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="mx-auto grid max-w-[1600px] items-center gap-16 px-6 py-32 sm:px-10 sm:py-44 lg:grid-cols-2 lg:gap-24 lg:px-16"
  >
    <FadeIn className="relative">
      <div className="overflow-hidden">
        <motion.img
          src={IMAGES.about}
          alt="An editorial celebration composed by SORA Events House"
          loading="lazy"
          initial={{ scale: 1.15 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 2.2, ease: EASE }}
          className="aspect-[4/5] w-full object-cover"
        />
      </div>
      <div className="absolute -bottom-12 right-2 w-52 rotate-2 bg-card p-2 shadow-[0_28px_60px_-20px_rgba(85,86,59,0.4)] transition-transform duration-700 hover:rotate-0 sm:-right-10 sm:w-64">
        <img
          src="/assets/brand-card-front.png"
          alt="SORA Events House brand card — illustrated Dubai celebration"
          loading="lazy"
          className="w-full"
        />
      </div>
    </FadeIn>

    <div className="relative mt-4 lg:mt-0">
      <FadeIn>
        <Eyebrow>The House</Eyebrow>
      </FadeIn>
      <FadeIn delay={0.1}>
        <h2 className="mt-8 font-serif text-[clamp(1.9rem,3.6vw,3.2rem)] font-light leading-[1.2] text-ink">
          “The most memorable celebrations are the ones that feel{" "}
          <span className="italic text-olive">unmistakably personal.</span>”
        </h2>
      </FadeIn>
      <FadeIn delay={0.2}>
        <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-ink/80">
          SORA Events House is an experiential agency creating distinctive
          moments for brands, businesses and private clients. We bring together
          strategy, creative direction, design, production and seamless
          execution to create experiences that feel intentional, elevated and
          unmistakably yours.
        </p>
      </FadeIn>
      <FadeIn delay={0.3}>
        <div className="mt-14 border-t border-line pt-10">
          <p className="font-serif text-3xl font-light text-ink">Bijal Sheth</p>
          <p className="mt-2 text-[10px] font-semibold uppercase tracking-[0.4em] text-olive">
            Founder &amp; Creative Director
          </p>
          <p className="mt-6 font-serif text-lg font-light italic text-ink/70">
            “Every celebration begins with a story. Ours is the craft of
            telling yours beautifully.”
          </p>
        </div>
      </FadeIn>
    </div>
  </section>
);
